import { useGatewayMutation } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import { CalendarEventsDocument } from "../apollo/__generated__/CalendarEvents.v2.generated";
import { CreateProposalDocument } from "./__generated__/CreateProposal.v2.generated";

export function useCreateProposal() {
  const [createProposal, { loading, error }] = useGatewayMutation(CreateProposalDocument, {
    refetchQueries: [CalendarEventsDocument],
  });

  return { createProposal, loading, error };
}
